import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import CustomerSearch from '@/src/javascripts/settings/customers/CustomerSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const customerIndex = document.querySelector('#customer-index')
  if (customerIndex && !customerIndex.__vue_app__) {
    createApp({ components: { BaseAlert, CustomerSearch } }).mount(customerIndex)
  }
})
